import { authApi } from 'api/auth/AuthApi';
import { borrowerApi } from 'prequalificationV2/api/BorrowersApi';
import { preQualificationApi } from 'prequalificationV2/api/PreQualification/PreQualificationApi';
import { completeBorrowerRegistrationThunk } from 'prequalificationV2/thunks/prequalification/completeBorrowerRegistration.thunk';

import { getAccountThunk } from './Auth/getAccount';
import { loginThunk } from './Auth/login';
import { logoutThunk } from './Auth/logout';
import { updateBorrowerThunk } from './Borrowers/updateBorrower';
import { getBorrowerByTokenThunk } from './Borrowers/getBorrowerByToken';
import { otpVerifyThunk } from './Auth/otpLogin';

export const login = loginThunk(authApi);
export const logout = logoutThunk(authApi);
export const updateBorrower = updateBorrowerThunk(borrowerApi);
export const otpVerify = otpVerifyThunk(authApi);

export const getAccount = getAccountThunk(authApi);
export const getBorrowerByToken = getBorrowerByTokenThunk(borrowerApi);
export const completeBorrowerRegistration = completeBorrowerRegistrationThunk(preQualificationApi);
